import { mediaConstants as mc } from './constants'

const initialState = {
  entityId: 0,
  pictures: {
    list: [],
    stats: {},
    loading: false
  },
  links: {
    list: [],
    stats: {},
    loading: false
  },
  documents: {
    list: [],
    stats: {},
    loading: false
  },
  error: null
}

export function media(state = initialState, action) {
  switch (action.type) {
    // Access
    case mc.GET_PICTURES_REQUEST: {
      const { isPagination, id } = action
      return {
        ...state,
        pictures: {
          ...state.pictures,
          list: isPagination ? [...state.pictures.list] : [],
          stats: isPagination ? { ...state.pictures.stats } : {},
          loading: true
        },
        entityId: id,
        error: null
      }
    }
    case mc.GET_PICTURES_SUCCESS: {
      const { isPagination, pictures_media } = action.updatedResponse
      let list = []
      let stats = {}
      list = pictures_media.files || []
      stats = pictures_media.stats
      let updatedList = [...state.pictures.list]

      if (isPagination && list) {
        updatedList = [...state.pictures.list, ...list]
      } else {
        updatedList = list ? [...list] : []
      }

      return {
        ...state,
        pictures: {
          ...state.pictures,
          list: updatedList,
          stats: stats && { ...stats },
          loading: false
        },
        error: null
      }
    }
    case mc.GET_PICTURES_FAILURE:
      return {
        ...state,
        pictures: {
          ...state.pictures,
          loading: false
        },
        error: action.error
      }

    case mc.GET_LINKS_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        links: {
          ...state.links,
          list: isPagination ? [...state.links.list] : [],
          stats: isPagination ? { ...state.links.stats } : {},
          loading: true
        },
        error: null
      }
    }
    case mc.GET_LINKS_SUCCESS: {
      const { isPagination, shared_links } = action.updatedResponse
      let list = []
      let stats = {}
      list = shared_links.links || []
      stats = shared_links.stats

      let updatedList = [...state.links.list]

      if (isPagination && list) {
        updatedList = [...state.links.list, ...list]
      } else {
        updatedList = list ? [...list] : []
      }

      return {
        ...state,
        links: {
          ...state.links,
          list: updatedList,
          stats: stats && { ...stats },
          loading: false
        },
        error: null
      }
    }
    case mc.GET_LINKS_FAILURE:
      return {
        ...state,
        links: {
          ...state.links,
          loading: false
        },
        error: action.error
      }

    case mc.GET_DOCUMENTS_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        documents: {
          ...state.documents,
          list: isPagination ? [...state.documents.list] : [],
          stats: isPagination ? { ...state.documents.stats } : {},
          loading: true
        },
        error: null
      }
    }
    case mc.GET_DOCUMENTS_SUCCESS: {
      const { isPagination, documents_media } = action.updatedResponse
      let list = []
      let stats = {}
      list = documents_media.files || []
      stats = documents_media.stats

      let updatedList = [...state.documents.list]

      if (isPagination && list) {
        updatedList = [...state.documents.list, ...list]
      } else {
        updatedList = list ? [...list] : []
      }

      return {
        ...state,
        documents: {
          ...state.documents,
          list: updatedList,
          stats: stats && { ...stats },
          loading: false
        },
        error: null
      }
    }
    case mc.GET_DOCUMENTS_FAILURE:
      return {
        ...state,
        documents: {
          ...state.documents,
          loading: false
        },
        error: action.error
      }

    default:
      return state
  }
}
